import { ValueSetExpansionContains } from "@medplum/fhirtypes";

import { isHcpcsLevelIICode } from "@/shared/billable-procedure-codes";

import { CPT_CODE_SYSTEM, HCPCS_CODE_SYSTEM } from "../constants/combined-procedure-codes";

/**
 * Tells whether a coding from the billable procedure codes ValueSet is a code a practice can bill.
 * The ValueSet already keeps only CPT billing codes, so every CPT coding passes. HCPCS codings pass
 * only when they are Level II codes, which drops the HCPCS modifiers.
 *
 * @param coding A coding returned by the billable procedure codes ValueSet.
 * @returns True when the coding is a CPT code or a HCPCS Level II code. A coding without a `code`
 * is never billable, so a true result also guarantees `code` is a string.
 */
export function isBillableHostedCoding(
  coding: ValueSetExpansionContains,
): coding is ValueSetExpansionContains & { code: string } {
  if (coding.code === undefined) return false;
  if (coding.system === CPT_CODE_SYSTEM) return true;
  return coding.system === HCPCS_CODE_SYSTEM && isHcpcsLevelIICode(coding.code);
}
